import { compose, lifecycle, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTServicesList from './BOTServicesList'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'

const withLifecycle = lifecycle({
  componentDidMount() {
    const { onClick, navigateToTireSearchOrShowYmme } = this.props
    document.querySelector('#hyperlocal-city-page-shop-tires-btn').addEventListener('click', navigateToTireSearchOrShowYmme)
    document.querySelectorAll('.hyperlocal-city-page-quick-app-btn').forEach(btn => btn.addEventListener('click', onClick))
  },
  componentWillUnmount() {
    const { onClick, navigateToTireSearchOrShowYmme } = this.props
    document.querySelector('#hyperlocal-city-page-shop-tires-btn').removeEventListener('click', navigateToTireSearchOrShowYmme)
    document.querySelectorAll('.hyperlocal-city-page-quick-app-btn').forEach(btn => btn.removeEventListener('click', onClick))
  }
})

export default compose(
  withType({ type: 'BOTServicesList' }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick,
  withNavigateToTireSearchOrShowYmme,
  withLifecycle
)(BOTServicesList)
